export default __webpack_public_path__ + "static/media/PlusOne.798b9dd7.svg";